import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import Home from './pages/home';
import Contact from './pages/contact';
import Login from './pages/login';
import Blogs from './pages/blogs';
import Placeholders from './pages/placeholders';
import PlaceholderEdit from './pages/placeholders/edit';
import PlaceholderCreate from './pages/placeholders/create';
import BlogsEdit from './pages/blogs/edit';
import BlogsCreate from './pages/blogs/create';
import Photos from './pages/photos';
import PhotosCreate from './pages/photos/create';
import Messages from './pages/messages';

const queryClient = new QueryClient()

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="contact" element={<Contact />} />
            <Route path="messages" element={<Messages />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="blogs/:id" element={<BlogsEdit />} />
            <Route path="blogs/create" element={<BlogsCreate />} />
            <Route path="placeholders" element={<Placeholders />} />
            <Route path="placeholders/:id" element={<PlaceholderEdit />} />
            <Route path="placeholders/create" element={<PlaceholderCreate />} />
            <Route path="photos" element={<Photos />} />
            <Route path="photos/create" element={<PhotosCreate />} />
            {/* <Route path="*" element={<NoPage />} /> */}
          </Route>
          <Route path="login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App;
